import styled from "styled-components";

export default styled.h1`
  font-weight: bold;
  font-size: 1.8rem;

  color: ${(props) => props.theme.colors.black};

  padding: 0.6rem;
  border-bottom: 3px solid ${(props) => props.theme.colors.primary};
`;
